<!-- 问题反馈 -->
<template>
    <div>
        <Panel title="系统参数查询">
            <template slot="buttons">
                <el-button title="常用参数查询" class="blue" @click="queryGeneralData" icon="el-icon-fa-search-minus">常用参数查询</el-button>
                <el-button title="全部参数查询" class="blue" @click="queryData" icon="el-icon-fa-search">全部参数查询</el-button>
                <el-button title="重置" class="yellow" @click="resetQuery" icon="el-icon-fa-refresh">重置</el-button>
            </template>

            <el-form ref="queryForm">
                <el-row>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item prop="quester" label="参数项">
                            <el-input v-model="form.pa_name" placeholder=""></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </Panel>

        <Panel title="系统参数列表">
            <template slot="buttons">
                <el-button title="添加" class="green" icon="el-icon-fa-plus" @click="doAdd">添加</el-button>
                <el-button title="删除" class="red" icon="el-icon-fa-trash" @click="doSeleDel">删除</el-button>
            </template>

            <PageTable hideExport hideTitle @selection-change="handleSelectionChange" ref="dataTable" :data="table.data" @load-data="dataTableLoad"
                       highlight-current-row stripe border height="calc(100vh - 281px)">
                <el-table-column type="selection" align='center' width="50px"></el-table-column>
                <el-table-column prop="paname" label="参数项" show-overflow-tooltip width="180px"></el-table-column>
                <el-table-column label="参数值" show-overflow-tooltip width="80px">

                    <template slot-scope="scope">
                        <div v-if='scope.row.pavalue===true'>
                            {{"开启"}}
                        </div>
                        <div v-else-if='scope.row.pavalue===false'>
                            {{"关闭"}}
                        </div>
                        <div v-else>
                            {{scope.row.pavalue}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="opcomment" label="备注" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="120px">
                    <template slot-scope="scope">
                        <el-switch v-if='scope.row.pavalue===true' width="80px" v-model='scope.row.pavalue' active-color="#13ce66"
                                   inactive-color="#ff4949" @change="change(scope.$index,scope.row.pavalue)">
                        </el-switch>
                        <el-switch v-else-if='scope.row.pavalue===false' width="80px" v-model='scope.row.pavalue' active-color="#13ce66"
                                   inactive-color="#ff4949" @change="change(scope.$index,scope.row.pavalue)">
                        </el-switch>
                        <div v-else>
                            <el-button type="primary" @click="doEdit(scope.$index, scope.row)" icon="el-icon-fa-edit" title="编辑">编辑
                            </el-button>
                            <el-button @click="doDelete( scope.$index, scope.row)" icon="el-icon-fa-trash" title="删除">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </PageTable>
        </Panel>

        <el-dialog close-on-press-escape append-to-body v-draggable :visible.sync="editor.show" title="参数编辑" width="800px">
            <div class="dialog-button">
                <el-button @click="refsaveSysPara" icon="el-icon-fa-save" title="保存" type="success">保存</el-button>
            </div>
            <SysParaEdit v-if="editor.show" ref="edit" :dat='postdat ' @upd='queryData() '></SysParaEdit>
        </el-dialog>
    </div>
</template>

<script>
    import SysParaEdit from "./SysParaEdit";
    import SysParaApi from "./SysPara";

    export default {
        name: "SysPara",
        components: {SysParaEdit},
        data() {
            return {
                rowr: "",
                postdat: {},
                form: {
                    pa_name: "",
                    orderField: "pa_name"
                },
                table: {
                    data: []
                },
                up: {
                    uuid: "",
                    orderField: "pa_name",
                    pa_name: "",
                    pa_value: "",
                    opcomment: ""
                },
                editor: {
                    show: false,
                    loading: false
                },
                multipleSelection: []
            };
        },
        mounted() {
            this.queryData();
        },
        methods: {
            // setPavalue(row, cellValue) {
            //   this.sw[row] = {
            //     open: true,
            //     close: false
            //   };
            // },
            // 打开编辑页面
            refsaveSysPara() {
                this.$refs.edit.saveSysPara();
            },
            change(row, rowstatus) {
                this.up.uuid = this.table.data[row].uuid;
                this.up.pa_name = this.table.data[row].paname;
                this.up.opcomment = this.table.data[row].opcomment;
                if (rowstatus === true) {
                    this.up.pa_value = "true";
                    SysParaApi.updateSysPara(this.up);
                } else if (rowstatus === false) {
                    this.up.pa_value = "false";
                    SysParaApi.updateSysPara(this.up);
                }
            },
            doEdit(index, rowData) {
                this.postdat = rowData;
                this.editor.show = true;
            },
            doAdd() {
                this.postdat = {};
                this.editor.show = true;
            },
            // 常用参数查询
            queryGeneralData(){
              this.editor.show = false;
              this.form.pa_type = "1";
              this.$refs.dataTable.load(this.form);
            },
            // 全部参数查询
            queryData() {
                this.editor.show = false;
                this.form.pa_type = null;
                this.$refs.dataTable.load(this.form);
            },
            dataTableLoad(params, resolve) {
                SysParaApi.querySysParaList(params)
                    .then(resolve) // 让表格解析你提供的数据 (主要解析页码等)
                    .then(respData => {
                        this.table.data = respData.datarows;
                        for (var i = 0; i < respData.totalRows; i++) {
                            if (this.table.data[i] && this.table.data[i].pavalue === "true") {
                                this.table.data[i].pavalue = true;
                            } else if (
                                this.table.data[i] &&
                                this.table.data[i].pavalue === "false"
                            ) {
                                this.table.data[i].pavalue = false;
                            }
                        }
                    }); // 本地也记录一下数据 (提供给表示显示的数据)
            },
            doDelete(index, rowData) {
                this.confirm().then(() => {
                    let array = [];
                    array.push(rowData.uuid);
                    SysParaApi.delSysPara(array).then(() => {
                        this.queryData();
                    });
                });
            },
            resetQuery() {
                this.form.pa_name = "";
                this.$refs["dataTable"].params.pageNum = 1;
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            doSeleDel() {
                if (this.multipleSelection.length !== 0) {
                    let array = [];
                    this.multipleSelection.forEach((value, index) => {
                        array.push(value.uuid);
                    });
                    this.$confirm("是否删除数据", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }).then(() => {
                        SysParaApi.delSysPara(array).then(() => {
                            this.queryData();
                        });
                    });
                } else {
                    this.$message({
                        message: "请选择数据！",
                        type: "warning"
                    });
                }
            }
        }
    };
</script>
